import { base64Decode, base64Encode } from './base64Impl.platform';

export function base64ToArrayBuffer(base64String: string): ArrayBufferLike {
  return base64Decode(base64String);
}

export function arrayBufferToBase64(buffer: ArrayBufferLike): string {
  // Explanation: Uint8Array.buffer returns ArrayBufferLike in TS 5.7 but is always ArrayBuffer at runtime
  return base64Encode(new Uint8Array(buffer).buffer as ArrayBuffer);
}

export function arrayBufferToHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer), (b) => b.toString(16).padStart(2, '0')).join('');
}

export function hexToArrayBuffer(hexStringArg: string): ArrayBuffer {
  const hexString = hexStringArg.replace(/[^0-9A-Fa-f]/g, '');

  if (hexString.length % 2 !== 0) {
    throw new Error('Invalid hex string');
  }

  const bytes = new Uint8Array(hexString.length / 2);
  for (let i = 0; i < hexString.length; i += 2) {
    bytes[i / 2] = parseInt(hexString.substr(i, 2), 16);
  }

  return bytes.buffer;
}
